'use strict';

angular.module('userRequestEditControllers')

.controller('ActionsController', ['$scope', '$state', '$stateParams', 'editAccessRequestService', function ($scope, $state, $stateParams, editAccessRequestService) {

    $scope.actionSubmit = null;

    // Cancel Request
    $scope.isCancellableRequest = function () {
        if (!$scope.userRequest.Enable || !$scope.authenticatedUser.IsInAdministrationGroup) {
            return false;
        }

        if ($scope.userRequest.IsEditable) {
            return true;
        }
        return !$scope.userRequest.IsCompleted;
    }

    $scope.cancelRequest = function () {
        $scope.actionSubmit = editAccessRequestService.request.cancel($scope.userRequest.UserAccessRequestID);
        $scope.actionSubmit.then(function (response) {
            if (response.statusText === 'OK') {
                $state.go('userAccessRequest', {},
                          { reload: true });
            }
        });
    }

    // Generic Response Submit
    var genericResponseSubmit = function (response) {
        if (!_.isUndefined(response.data.GrowlMessages)) {
            $state.go('userAccessRequest.edit.validationMessages',
                      { userAccessRequestId: $stateParams.userAccessRequestId },
                      { reload: true });
        }

        if (response.statusText === 'OK' && _.isUndefined(response.data.GrowlMessages)) {
            $state.go('userAccessRequest.edit.events',
                      { userAccessRequestId: $stateParams.userAccessRequestId },
                      { reload: true });
        }
    }

    // Modify Request
    $scope.modifyRequest = function () {
        $scope.actionSubmit = editAccessRequestService.request.modify($scope.userRequest.UserAccessRequestID);
        $scope.actionSubmit.then(genericResponseSubmit);
    }

    // Manual Supervisor Approval
    $scope.withManualSupervisorApproval = function () {
        if (!$scope.userRequest.Enable || !$scope.authenticatedUser.IsInAdministrationGroup) return false;
        return $scope.userRequest.IsSupervisorPendingAuthorization;
    }

    $scope.submitWithManualSupervisorApproval = function () {
        $scope.actionSubmit = editAccessRequestService.request.manualSupervisorApprovalSubmit($scope.userRequest.UserAccessRequestID);
        $scope.actionSubmit.then(genericResponseSubmit);
    }

    // Special Submit
    $scope.specialSubmitCtxt = {
        noSupervisorAuthorization: false,
        noSystemOwnerAuthorization: false
    }

    $scope.specialSubmit = function () {
        $scope.actionSubmit = editAccessRequestService.request.specialSubmit($scope.userRequest.UserAccessRequestID,
                                                                             $scope.specialSubmitCtxt.noSupervisorAuthorization,
                                                                             $scope.specialSubmitCtxt.noSystemOwnerAuthorization);
        $scope.actionSubmit.then(genericResponseSubmit);
    }

    // Submit
    $scope.submitRequest = function () {
        $scope.actionSubmit = editAccessRequestService.request.submit($scope.userRequest.UserAccessRequestID);
        $scope.actionSubmit.then(genericResponseSubmit);
    }
}]);
